<div class="access-groups">
  <div class="access-groups-header">
    <div class="access-groups-title">{{ 'userManagementPage.accessGroupsPage.title' | labelsProvider }}</div>

    <div class="add-button-container">
      <app-button
        [isEnabled]="true"
        buttonIconPath="assets/images/common/plus.svg"
        tooltipPosition="left"
        (buttonClicked)="openCreateAccessGroupDialog()"
        [buttonTextLabelPath]="'userManagementPage.accessGroupsPage.createAccessGroup'"
      ></app-button>
    </div>
  </div>

  <app-access-groups-filters [pageFilters]="pageFilters" />

  <div class="access-groups-header">
    @if (pageInfo().totalItems > -1) {
      <div class="access-groups-amount">{{ pageInfo().totalItems | number }} {{ 'access groups' }}</div>
    }
    <div class="access-groups-actions">
      <app-columns-selection
        class="columns-selection"
        [pageName]="pageName"
        [columns]="columns()"
        (columnsSelected)="columnsSelected($event)"
      />
    </div>
  </div>

  <div class="access-groups-table">
    <app-prime-table
      #table
      [tabelWithIcon]="false"
      [withRowSelection]="false"
      [useBuiltInTextPopup]="false"
      queryParamProperty="accessGroups"
      [data$]="accessGroups$"
      [rowsPerPage]="defaultPageSize()"
      [columns]="columns()"
      [isLoading]="isLoading()"
      [withCheckboxSelection]="false"
      [withActions]="true"
      (rowActionOnClick)="onRowActionClicked($event)"
      [sortedColumn$]="sortedColumn$"
      [pageInfo]="pageInfo()"
      tableNotFoundText="No access groups found"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
    />
  </div>
</div>
